import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSpinner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Spinner"
    viewBox="0 0 56 56"
    {...props}
  >
    <path
      fill="currentColor"
      d="M30.188 6.854A2.18 2.18 0 0 0 28 4.667a2.18 2.18 0 0 0-2.188 2.187v7.292c0 1.212.976 2.187 2.188 2.187a2.18 2.18 0 0 0 2.188-2.187zm0 35A2.18 2.18 0 0 0 28 39.667a2.18 2.18 0 0 0-2.188 2.187v7.292c0 1.212.976 2.187 2.188 2.187a2.18 2.18 0 0 0 2.188-2.187zM4.666 28c0 1.212.975 2.188 2.187 2.188h7.292A2.18 2.18 0 0 0 16.333 28a2.18 2.18 0 0 0-2.187-2.188H6.854A2.18 2.18 0 0 0 4.667 28Zm37.187-2.188A2.18 2.18 0 0 0 39.667 28c0 1.212.975 2.188 2.187 2.188h7.292A2.18 2.18 0 0 0 51.333 28a2.18 2.18 0 0 0-2.187-2.188zm2.643-14.31a2.18 2.18 0 0 0-3.09 0l-5.158 5.16a2.18 2.18 0 0 0 0 3.09c.856.847 2.242.856 3.09 0l5.158-5.16a2.18 2.18 0 0 0 0-3.09M19.751 39.34a2.18 2.18 0 0 0 0-3.09c-.857-.848-2.242-.857-3.09 0l-5.158 5.159a2.18 2.18 0 0 0 0 3.09c.856.847 2.242.856 3.09 0l5.158-5.16Zm-8.248-27.836a2.18 2.18 0 0 0 0 3.09l5.158 5.158a2.18 2.18 0 0 0 3.09 0c.848-.856.857-2.242 0-3.09l-5.159-5.158a2.18 2.18 0 0 0-3.09 0ZM39.348 36.25a2.18 2.18 0 0 0-3.09 0c-.848.856-.857 2.242 0 3.09l5.15 5.158a2.18 2.18 0 0 0 3.09 0c.847-.856.856-2.242 0-3.09l-5.16-5.158z"
    />
  </svg>
);
export default SvgSpinner;
